var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import commonMessages from '../../common/messages';

import InfoIconWithTooltip from './InfoIconWithTooltip';
import StandardLabel from './StandardLabel';
import HiddenLabel from './HiddenLabel';

import './Label.scss';

var OptionalFormattedMessage = function OptionalFormattedMessage() {
    return React.createElement(
        'span',
        { className: 'label-optional' },
        '(',
        React.createElement(FormattedMessage, commonMessages.optional),
        ')'
    );
};

var Label = function Label(_ref) {
    var text = _ref.text,
        tooltip = _ref.tooltip,
        infoTooltip = _ref.infoTooltip,
        infoIconProps = _ref.infoIconProps,
        showOptionalText = _ref.showOptionalText,
        hideLabel = _ref.hideLabel,
        children = _ref.children;

    var labelContent = [React.createElement(
        'span',
        { key: 'labelText' },
        text
    ), showOptionalText ? React.createElement(OptionalFormattedMessage, { key: 'optionalMessage' }) : null];

    if (infoTooltip) {
        labelContent.push(React.createElement(InfoIconWithTooltip, {
            iconProps: _extends({ className: 'tooltip-icon' }, infoIconProps),
            key: 'infoTooltip',
            tooltipText: infoTooltip
        }));
    }

    if (hideLabel) {
        return React.createElement(
            HiddenLabel,
            { labelContent: labelContent },
            children
        );
    }

    return React.createElement(
        StandardLabel,
        { labelContent: labelContent, tooltip: tooltip },
        children
    );
};

Label.propTypes = {
    children: PropTypes.node.isRequired,
    infoIconProps: PropTypes.object,
    infoTooltip: PropTypes.node,

    /** The label text */
    text: PropTypes.node.isRequired,

    /** Whether to show the `(Optional)` text next to the label for an optional field */
    showOptionalText: PropTypes.bool,

    /** Tooltip text for the label */
    tooltip: PropTypes.node,

    /** Whether the text of the label should be accessibly hidden */
    hideLabel: PropTypes.bool
};
export default Label;
import PropTypes from 'prop-types';